import React, { ReactElement } from 'react'
import { Text } from 'theme-ui'

export default function CustomDay({ dayOfMonth }: { dayOfMonth: number }): ReactElement {
  return <Text variant="size12Weight700">{dayOfMonth}</Text>
}
